import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {MAX_PLAN_CONDITION_COUNT} from 'studies/typed/shared/procedure-runs/execution-status/useMethodExecutionLimitState';
import {getProcedureRunConditionTextForProcedureType} from 'studies/TypedStudyUtils';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

export default function MethodExecutionLimitError({
  replicateLimit,
  procedureType,
}: {
  replicateLimit: number;
  procedureType: ProcedureType;
}): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.ERROR}
      text={
        `Cannot exceed ${replicateLimit} total ${pluralize(replicateLimit, 'replicate')}. ` +
        `Reduce number of ${getProcedureRunConditionTextForProcedureType(procedureType, {plural: true})} or replicates.`
      }
    />
  );
}

export function MethodExecutionConditionLimitError({
  procedureType,
}: {
  procedureType: ProcedureType;
}): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.ERROR}
      text={`Cannot exceed ${MAX_PLAN_CONDITION_COUNT} total ${getProcedureRunConditionTextForProcedureType(procedureType, {plural: true})}. `}
    />
  );
}
